import { useState } from 'react';
import LoadingComponent from './../../widgets/LoadingComponent';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { getData } from '../../api/ApiRest';
import { FaDownload } from "react-icons/fa6";
import Form from 'react-bootstrap/Form';
import { NumericFormat } from 'react-number-format';
import { exportToExcel } from 'react-json-to-excel';
import { Fragment } from 'react';
import { FaPlus, FaMinus } from "react-icons/fa6";
import Card from 'react-bootstrap/Card';



function EmisionInstancia() {
    const [loading, setLoading] = useState(false);
    const [buscarEmisionesInstancia, setBuscarEmisionesInstancia] = useState({ MMM: new Date().getMonth() + 1, YYYY: new Date().getFullYear() });
    const [dataEmision, setDataEmision] = useState([]);
    const [dataEmisionAgrupado, setDataEmisionAgrupado] = useState([]);


    const getEmisionInstancia = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Configuracion/Reporte/GetReporteEmisionInstancia', {
            CompanyId: '',
            MMM: buscarEmisionesInstancia.MMM,
            YYYY: buscarEmisionesInstancia.YYYY
        }).then(response => {
            console.log(response);
            if (response.status === true) {
                setDataEmision(response.listado);
                setDataEmisionAgrupado(response.agrupados);
            } else {
                alert('algo salio mal al cargar la información');
            }

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
            alert('Algo salio mal, por favor contacta a soporte');
        })

    }


    const descargarExcel = () => {
        if (dataEmision.length === 0) {
            alert('No hay datos para descargar');
            return;
        }

        exportToExcel(dataEmision, 'EmisionInstancia');
    }


    const expandItem = (item, index, estado) => {
        let listado = [...dataEmisionAgrupado];

        listado[index].expandido = estado;

        setDataEmisionAgrupado(listado);
    }


    const sumArray = (datos = [], campo = '') => {
        let Total = 0;

        for (let i = 0; i < datos.length; i++) {
            const item = datos[i];

            Total += item[campo]
        }

        return Total;
    }



    return <div className='BodyComponent'>
        <LoadingComponent Loading={loading} />
        <h4 className='text-center'>
            REPORTE DE EMISION POR INSTANCIA
        </h4>

        <Form onSubmit={getEmisionInstancia}>

            <div className='row'>

                <div className='col-md-4'>
                    <FloatingLabel
                        controlId='EmisionMMM'
                        label="Mes"
                        className="mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={buscarEmisionesInstancia.MMM}
                            onChange={event => {
                                setBuscarEmisionesInstancia({
                                    ...buscarEmisionesInstancia,
                                    MMM: event.target.value
                                })
                            }}
                        >
                            <option value="">TODOS</option>
                            {[{ id: 1, name: 'Enero' }, { id: 2, name: 'Febrero' },
                            { id: 3, name: 'Marzo' }, { id: 4, name: 'Abril' },
                            { id: 5, name: 'Mayo' }, { id: 6, name: 'Junio' },
                            { id: 7, name: 'Julio' }, { id: 8, name: 'Agosto' },
                            { id: 9, name: 'Septiembre' }, { id: 10, name: 'Octubre' },
                            { id: 11, name: 'Noviembre' }, { id: 12, name: 'Diciembre' }].map((item, index) => (
                                <option value={item.id} key={index}>{item.name}</option>
                            ))}
                        </Form.Select>
                    </FloatingLabel>
                </div>

                <div className='col-md-4'>
                    <FloatingLabel
                        controlId='EmisionYYYY'
                        label="Año"
                        className="mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={buscarEmisionesInstancia.YYYY}
                            onChange={event => {
                                setBuscarEmisionesInstancia({
                                    ...buscarEmisionesInstancia,
                                    YYYY: event.target.value
                                })
                            }}
                        >
                            <option value="">TODOS</option>
                            {[2024, 2025, 2026].map((item, index) => (
                                <option value={item} key={index}>{item}</option>
                            ))}
                        </Form.Select>
                    </FloatingLabel>
                </div>

                <div className='col-md-1'>
                    <button className='btn btn-sm btn-primary mt-2' type='submit'>
                        Buscar
                    </button>
                </div>
                <div className='col-md-1'>
                    <button type='button' className='btn btn-sm btn-secondary  mt-2' onClick={descargarExcel} title='Descargar a Excel'>
                        <FaDownload size={'1rem'} />
                    </button>
                </div>

            </div>

        </Form>

        <br />

        <Card>
            <Card.Header className='text-center bg-primary text-white fw-bold'>RESUMEN</Card.Header>
            <Card.Body>

                <table className='table table-sm table-bordered table-hover'>
                    <thead>
                        <tr>
                            <th>
                                EMITIDAS
                            </th>
                            <th>
                                PENDIENTES
                            </th>
                            <th>
                                TOTAL
                            </th>
                            <th>
                                %
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='text-center'>
                                <NumericFormat
                                    displayType='text'
                                    thousandSeparator=','
                                    value={sumArray(dataEmisionAgrupado, 'emitidas')} />
                            </td>
                            <td className='text-center'>
                                <NumericFormat
                                    displayType='text'
                                    thousandSeparator=','
                                    value={sumArray(dataEmisionAgrupado, 'pendientes')} />
                            </td>
                            <td className='text-center'>
                                <NumericFormat
                                    displayType='text'
                                    thousandSeparator=','
                                    value={sumArray(dataEmisionAgrupado, 'total')} />
                            </td>
                            <td className='text-center'>
                                <NumericFormat
                                    displayType='text'
                                    thousandSeparator=','
                                    decimalScale={2}
                                    value={sumArray(dataEmisionAgrupado, 'emitidas') / sumArray(dataEmisionAgrupado, 'total') * 100} />
                            </td>
                        </tr>
                    </tbody>
                </table>

            </Card.Body>
        </Card>

        <br />

        <div className='table-responsive'>
            <table className='table table-sm table-bordered table-hover'>
                <thead>
                    <tr>
                        <th>
                            #
                        </th>
                        <th>
                            Empresa
                        </th>
                        <th>
                            Emitidas
                        </th>
                        <th>
                            Pendientes
                        </th>
                        <th>
                            Total
                        </th>
                        <th>
                            %
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {dataEmisionAgrupado.map((item, index) => (
                        <Fragment key={index}>
                            <tr >
                                <td className='text-center'>
                                    {index + 1}
                                </td>
                                <td>
                                    <button type='button'
                                        className={item.expandido === false ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-danger'}
                                        onClick={() => expandItem(item, index, item.expandido === false ? true : false)}>
                                        {item.expandido === false ?
                                            <FaPlus /> : <FaMinus />}
                                    </button>
                                    {item.company}
                                </td>
                                <td className='text-center'>
                                    <NumericFormat
                                        displayType='text'
                                        thousandSeparator=','
                                        value={item.emitidas} />
                                </td>
                                <td className='text-center'>
                                    <NumericFormat
                                        displayType='text'
                                        thousandSeparator=','
                                        value={item.pendientes} />
                                </td>
                                <td className='text-center'>
                                    <NumericFormat
                                        displayType='text'
                                        thousandSeparator=','
                                        value={item.total} />
                                </td>
                                <td className='text-center'>
                                    <NumericFormat
                                        displayType='text'
                                        thousandSeparator=','
                                        decimalScale={1}
                                        defaultValue={0}
                                        value={item.porc_Emitido} />
                                </td>
                            </tr>
                            {item.expandido === true ?
                                <tr>
                                    <td colSpan={6}>
                                        <table className='table table-sm table-bordered'>
                                            <thead>
                                                <tr className='table-dark text-white'>
                                                    <th>
                                                        Instancia
                                                    </th>
                                                    <th>
                                                        Prefijo
                                                    </th>
                                                    <th>
                                                        Emitidas
                                                    </th>
                                                    <th>
                                                        Pendientes
                                                    </th>
                                                    <th>
                                                        Total
                                                    </th>
                                                    <th>
                                                        %
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {item.detalles.map((item2, index2) => (
                                                    <tr key={index2}>
                                                        <td>
                                                            {item2.url}
                                                        </td>
                                                        <td className='text-center'>
                                                            {item2.prefijo}
                                                        </td>
                                                        <td className='text-center'>
                                                            <NumericFormat
                                                                displayType='text'
                                                                thousandSeparator=','
                                                                value={item2.emitidas} />
                                                        </td>
                                                        <td className='text-center'>
                                                            <NumericFormat
                                                                displayType='text'
                                                                thousandSeparator=','
                                                                value={item2.pendientes} />
                                                        </td>
                                                        <td className='text-center'>
                                                            <NumericFormat
                                                                displayType='text'
                                                                thousandSeparator=','
                                                                value={item2.total} />
                                                        </td>
                                                        <td className='text-center'>
                                                            <NumericFormat
                                                                displayType='text'
                                                                thousandSeparator=','
                                                                decimalScale={1}
                                                                defaultValue={0}
                                                                value={item2.porc_Emitido} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                                : null}

                        </Fragment>
                    ))}
                </tbody>
            </table>
        </div>

    </div>

}


export default EmisionInstancia;